import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { select } from '@ngneat/elf';
import { FundingSourceStateProps, fundingSourceStateStore, fundingSourceInitialState } from './funding-source-state.store';

@Injectable({
  providedIn: 'root',
})
export class FundingSourceRepository extends BaseStoreRepository<FundingSourceStateProps> {
  constructor() {
    super(fundingSourceStateStore.pipe(select(state => state)), fundingSourceStateStore, fundingSourceInitialState);
  }
}
